import React from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'
import { useTranslate } from 'react-admin'
import { Switch, Typography } from '@material-ui/core'
import GAME_EVENT_FORM_BROADCAST_FIELDS from '../../utils/constants/gameEventFormBroadcastFields'
import { isFormFieldDisabled } from '../../utils/helpers/isFieldDisabled'

// Per-game override of the org's shared-revenue flag. The form seeds it from the org, and the
// backend locks it once the stream leaves "scheduled", so it is disabled in every other state.
// A record-only game goes through no MediaLive channel and plays no ads, so there is no revenue
// to share and the toggle is not offered at all.
const EventFormSharedRevenueToggle = ({ state }) => {
  const translate = useTranslate()
  const { values, setFieldValue } = useFormikContext()
  const field = GAME_EVENT_FORM_BROADCAST_FIELDS.SHARED_REVENUE

  if (!values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_BROADCAST]) return null

  return (
    <div className='div-flex-space-between'>
      <Typography style={{ fontSize: 14, fontWeight: 500, color: '#3C3C3C' }}>
        {translate('ra.gameDrawer.sharedRevenue')}
      </Typography>
      <Switch
        name={field}
        color='primary'
        checked={Boolean(values[field])}
        disabled={isFormFieldDisabled(state)}
        onChange={() => setFieldValue(field, !values[field])}
      />
    </div>
  )
}

EventFormSharedRevenueToggle.propTypes = {
  state: PropTypes.string,
}

export default EventFormSharedRevenueToggle
